import Box from "@mui/material/Box";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import React, { FC } from "react";
import { useFaqDetails } from "../../context";
import { StyledPrimaryButton, StyledSecondaryButton } from "./styled";

const ActionButtons: FC = () => {
  const { isSubmitting, disabled, handleSaveDraft, handleSaveActive } =
    useFaqDetails();
  const { allowed: hasWriteAccess } = useRolePermission("faq:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission(
    "faq:translations:write",
  );

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <Box gap="1rem" display="flex" flexDirection="row" alignItems="center">
        <StyledPrimaryButton
          title="Save"
          size="small"
          disabled={disabled}
          onClick={handleSaveActive}
          loading={isSubmitting}
        />
      </Box>
    );
  }

  return (
    <Box gap="1rem" display="flex" flexDirection="row" alignItems="center">
      <StyledSecondaryButton
        title="Save as draft"
        size="small"
        color="secondary"
        variant="outlined"
        disabled={disabled}
        onClick={handleSaveDraft}
        loading={isSubmitting}
      />
      <StyledPrimaryButton
        title="Save and Publish"
        size="small"
        disabled={disabled}
        onClick={handleSaveActive}
        loading={isSubmitting}
      />
    </Box>
  );
};

export default ActionButtons;
